import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { customAnim } from './route-animation';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [customAnim]
})
export class AppComponent {
  title = 'gastro-site-web';

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }
}
